<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center">
            <h1 class="h1">Статистика</h1>
        </header>

        <div v-if="loading" class="pt-4 mt-3">Loading...</div>

        <template v-else>
            <section class="cabinet-section pt-4">
                <h2 class="h2 mb-4">Всего</h2>

                <div class="dashboard-scrollable__wrap">
                    <div class="dashboard-scrollable__content">
                        <div class="row dashboard-row">
                            <div
                                class="col-md-4 dashboard-card dashboard-card--line"
                            >
                                <div class="dashboard-card__content">
                                    <div class="dashboard-card__title">
                                        Просмотров
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="dashboard-card__icon">
                                            <img
                                                src="/img/icons/eye.svg"
                                                alt=""
                                            />
                                        </div>
                                        <div class="dashboard-card__total">
                                            {{
                                                categoryStats.overall_statistics
                                                    .views
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-md-4 dashboard-card dashboard-card--line"
                            >
                                <div class="dashboard-card__content">
                                    <div class="dashboard-card__title">
                                        Сохранений в списки
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="dashboard-card__icon">
                                            <img
                                                src="/img/icons/star-2.svg"
                                                alt=""
                                            />
                                        </div>
                                        <div class="dashboard-card__total">
                                            {{
                                                categoryStats.overall_statistics
                                                    .list
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-md-4 dashboard-card dashboard-card--line"
                            >
                                <div class="dashboard-card__content">
                                    <div class="dashboard-card__title">
                                        Заказов
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="dashboard-card__icon">
                                            <img
                                                src="/img/icons/orders-2.svg"
                                                alt=""
                                            />
                                        </div>
                                        <div class="dashboard-card__total">
                                            {{
                                                categoryStats.overall_statistics
                                                    .shop
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mt-4 pt-3 pt-md-0 mt-md-5 mb-5 pb-3">
                <h2 class="h2 mb-3">По категориям</h2>

                <p v-if="noDataStatistic" class="text">Данные отсутствуют</p>

                <div v-else>
                    <CategoryCard
                        v-for="category in categoryStats.categories_views_statistics"
                        :key="category.CategoryID"
                        :category="category"
                    />
                </div>
            </section>

            <section>
                <h2 class="h2 mb-3">По изделиям</h2>

                <p v-if="noDataStatistic" class="text">Данные отсутствуют</p>

                <template v-else>
                    <p class="filters-panel_text text mb-4">
                        Отображаются только те изделия, по которым есть хотя бы
                        один просмотр / сохранение в список / заказ. Изделия, у
                        которых по всем трем параметрам 0, не выводятся.
                    </p>

                    <section class="filters-panel row filters-panel__row">
                        <div
                            class="col-lg-5 filters-panel__col d-flex d-lg-block"
                        >
                            <div class="filters-panel-search">
                                <label
                                    class="filters-panel-search__label"
                                    for="filters-panel-search__input"
                                    @click="onSearch"
                                ></label>
                                <input
                                    id="filters-panel-search__input"
                                    v-model="search"
                                    type="text"
                                    name=""
                                    class="app-input filters-panel-search__input"
                                    placeholder="Поиск"
                                    @keyup.enter="onSearch"
                                />
                                <label
                                    v-if="search"
                                    class="filters-panel-search__clear"
                                    for="filters-panel-search__input"
                                    @click="onClearSearch"
                                ></label>
                            </div>
                            <div class="position-relative d-lg-none">
                                <button
                                    type="button"
                                    class="cabinet-btn cabinet-btn--filter cabinet-btn--default filters-panel__mob-btn d-lg-none ml-3 js-open-mob-filters"
                                    @click="level1mFilter = true"
                                ></button>
                                <div
                                    v-if="appliedFiltersCount"
                                    class="mobile-filter__selected-label mobile-filter__selected-label--circle"
                                >
                                    {{ appliedFiltersCount }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-lg-2 filters-panel__col d-none d-lg-block"
                        >
                            <select-picker
                                :current-value="filter.categories.value"
                                :options="categories"
                                key-value="CategoryID"
                                key-title="Name"
                                select-title="Категория"
                                select-width="100%"
                                :is-multiple="true"
                                :classes="['select']"
                                @onChange="
                                    onSelectPickerChange('categories', $event)
                                "
                            />
                        </div>
                        <div
                            class="col-lg-2 filters-panel__col d-none d-lg-block"
                        >
                            <select-picker
                                :current-value="filter.types.value"
                                :options="typesByCategories"
                                key-value="TypeID"
                                key-title="Name"
                                select-title="Вид изделия"
                                select-width="100%"
                                :is-multiple="true"
                                :classes="['select']"
                                @onChange="
                                    onSelectPickerChange('types', $event)
                                "
                            />
                        </div>
                        <div
                            class="col-lg-2 filters-panel__col d-none d-lg-block"
                        >
                            <select-picker
                                :current-value="filter.materials.value"
                                :options="materials"
                                key-value="MaterialID"
                                key-title="Name"
                                select-title="Материал"
                                select-width="100%"
                                :is-multiple="true"
                                :classes="['select']"
                                @onChange="
                                    onSelectPickerChange('materials', $event)
                                "
                            />
                        </div>

                        <div
                            class="col-lg-2 filters-panel__col d-none d-lg-block"
                        >
                            <select-picker
                                :current-value="filter.finenesses.value"
                                :options="finenessesByMaterials"
                                key-value="FinenessID"
                                key-title="Value"
                                select-title="Проба"
                                select-width="100%"
                                :is-multiple="true"
                                :classes="['select']"
                                @onChange="
                                    onSelectPickerChange('finenesses', $event)
                                "
                            />
                        </div>
                        <div
                            class="col-lg-3 filters-panel__col d-none d-lg-block"
                        >
                            <select-picker
                                :current-value="filter.insertMaterials.value"
                                :options="insertMaterials"
                                key-value="MaterialID"
                                key-title="Name"
                                select-title="Материал вставки"
                                select-width="100%"
                                :is-multiple="true"
                                :classes="['select']"
                                @onChange="
                                    onSelectPickerChange(
                                        'insertMaterials',
                                        $event
                                    )
                                "
                            />
                        </div>
                        <div
                            class="col-lg-2 filters-panel__col d-none d-lg-block"
                        >
                            <select-picker
                                :current-value="filter.collections.value"
                                :options="supplierCollections"
                                key-value="CollectionID"
                                key-title="Name"
                                select-title="Коллекция"
                                select-width="100%"
                                :is-multiple="true"
                                :classes="['select']"
                                @onChange="
                                    onSelectPickerChange('collections', $event)
                                "
                            />
                        </div>
                        <div
                            class="col-lg-2 filters-panel__col d-none d-lg-block"
                        >
                            <select-picker
                                :current-value="filter.visibility.value"
                                :options="supplierVisibility"
                                key-value="id"
                                key-title="title"
                                select-title="Видимость"
                                select-width="100%"
                                :is-multiple="true"
                                :classes="['select']"
                                @onChange="
                                    onSelectPickerChange('visibility', $event)
                                "
                            />
                        </div>
                        <div
                            class="col-lg-2 filters-panel__col d-none d-lg-block"
                        >
                            <button
                                v-if="!isAllDefaultValues"
                                type="button"
                                class="cabinet-btn cabinet-btn--default"
                                @click="resetFilters()"
                            >
                                Сбросить
                            </button>
                        </div>
                    </section>

                    <section>
                        <div
                            class="flex flex-column flex-justify-sb mobile-filter"
                            :class="{ 'mobile-filter--open': level1mFilter }"
                        >
                            <div class="mobile-filter__wrap">
                                <div
                                    class="flex flex-justify-sb flex-align-center mobile-filter__header"
                                >
                                    <div class="h3 mobile-filter__title">
                                        Фильтр
                                        <span
                                            class="mobile-filter__selected-count"
                                        ></span>
                                    </div>
                                    <button
                                        type="button"
                                        class="mobile-filter__close-btn"
                                        @click="level1mFilter = false"
                                    ></button>
                                </div>

                                <ul class="mobile-filter__list">
                                    <li
                                        v-for="(filterKey, i) in Object.keys(
                                            filter
                                        )"
                                        :key="i"
                                        class="mobile-filter__list-item"
                                        @click="setlevel2mFilters(filterKey)"
                                    >
                                        <div
                                            class="d-flex justify-content-between"
                                        >
                                            {{ filter[filterKey].title }}
                                            <div
                                                v-if="
                                                    !filter[filterKey].isDefault
                                                "
                                                class="mobile-filter__selected-label d-flex align-items-center"
                                            >
                                                {{
                                                    filter[filterKey].value
                                                        .length
                                                }}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div class="d-flex p-3 mobile-filter__footer">
                                <button
                                    type="button"
                                    class="cabinet-btn mr-3"
                                    @click="level1mFilter = false"
                                >
                                    Показать
                                </button>
                                <button
                                    type="button"
                                    class="cabinet-btn cabinet-btn--default"
                                    @click="resetFilters()"
                                >
                                    Сбросить
                                </button>
                            </div>
                        </div>

                        <div
                            v-if="!!level2mFilter"
                            id="mobile-filter-level2"
                            class="flex flex-column flex-justify-sb mobile-filter"
                            :class="{ 'mobile-filter--open': !!level2mFilter }"
                        >
                            <div class="mobile-filter__wrap">
                                <div
                                    class="flex flex-justify-sb flex-align-center mobile-filter__header"
                                >
                                    <button
                                        type="button"
                                        class="mobile-filter__back-btn"
                                        @click="level2mFilter = false"
                                    ></button>
                                    <div class="h3 mobile-filter__title">
                                        {{ filter[level2mFilter].title }}
                                    </div>
                                    <div></div>
                                </div>

                                <ul class="mobile-filter__list">
                                    <!-- {{ this[filter[level2mFilter].srcName] }} -->
                                    <!-- eslint-disable -->
                                    <li
                                        v-for="(item, i) in this[
                                            filter[level2mFilter].srcName
                                        ]"
                                        :key="i"
                                        class="mobile-filter__list-item"
                                    >
                                        <label class="custom-checkbox"
                                            >{{ item[filter[level2mFilter].srcKeyTitle] }}
                                            <input
                                                v-model="filter[level2mFilter].value"
                                                type="checkbox"
                                                :value="
                                                    item[filter[level2mFilter].srcKeyVal]
                                                "
                                                @change="onFilterChange(level2mFilter)"
                                            />
                                            <span class="custom-checkbox__checkmark"></span>
                                        </label>
                                    </li>
                                    <!-- eslint-enable -->
                                </ul>
                            </div>

                            <div class="d-flex p-3 mobile-filter__footer">
                                <button
                                    type="button"
                                    class="cabinet-btn mr-3"
                                    @click="closeAllmFilters"
                                >
                                    Показать
                                </button>
                                <button
                                    type="button"
                                    class="cabinet-btn cabinet-btn--default"
                                    @click="resetFilters()"
                                >
                                    Сбросить
                                </button>
                            </div>
                        </div>
                    </section>

                    <p v-if="loadingProducts">Loading...</p>

                    <div v-else-if="errors.getProducts">
                        <div class="error text-center">
                            <div class="error-image">
                                <img src="/img/icons/error.svg" alt="" />
                            </div>
                            <div class="error-title">
                                Упс! Что-то пошло не так.
                            </div>
                            <div class="error-button">
                                <button
                                    type="button"
                                    class="cabinet-btn"
                                    @click="tryLoadingProducts"
                                >
                                    Попробовать еще раз
                                </button>
                            </div>
                        </div>
                    </div>

                    <div
                        v-else-if="!paginatedProducts.length"
                        class="w-md-50 text-center ml-auto mr-auto pt-5 pb-5"
                    >
                        <img
                            v-if="search.length === 0"
                            src="/img/icons/empty-goods.svg"
                            class="dashboard-empty__img ofi"
                        />
                        <img
                            v-else
                            src="/img/icons/empty-search.svg"
                            class="dashboard-empty__img dashboard-empty__img--search ofi"
                        />
                        <div class="dashboard-empty__title pt-5">
                            {{
                                search || !isAllDefaultValues
                                    ? ' По вашему запросу ничего не найдено.'
                                    : 'У вас пока что нет ни одного изделия.'
                            }}
                        </div>
                    </div>

                    <div v-show="!loadingProducts && paginatedProducts.length">
                        <section class="cabinet-table-options-wrap mb-0">
                            <div
                                class="cabinet-table-options flex flex-align-center pt-0 pb-0"
                            >
                                <div class="d-none d-md-block">
                                    {{
                                        pagination.page * pagination.pageSize +
                                            1 -
                                            pagination.pageSize
                                    }}
                                    -
                                    {{
                                        Math.min(
                                            pagination.page *
                                                pagination.pageSize,
                                            pagination.totalProducts
                                        )
                                    }}

                                    из {{ pagination.totalProducts }}
                                </div>

                                <div
                                    class="cabinet-table-options__sort flex flex-align-center ml-md-auto mr-3"
                                >
                                    <div
                                        class="dropdown bootstrap-select select js--single"
                                    >
                                        <select-picker
                                            :current-value="order_by"
                                            :options="sortVariations"
                                            key-value="value"
                                            key-title="title"
                                            select-width="257"
                                            :classes="['select']"
                                            @onChange="onSortChange($event)"
                                        />
                                    </div>
                                </div>

                                <!-- <div class="cabinet-table-options__sort flex flex-align-center ml-md-auto">
                                    <div class="dropdown bootstrap-select select js--single mr-0" style="width: 257px;">
                                        <select class="select js-selectpicker-single mr-0" data-width="257px" tabindex="-98">
                                            <option>По количеству просмотров</option>
                                            <option>По количеству сохранений</option>
                                            <option>По количеству заказов</option>
                                        </select>
                                        <button type="button" class="btn dropdown-toggle btn-light" data-toggle="dropdown" role="button" title="По количеству просмотров" aria-expanded="false">
                                            <div class="filter-option">
                                                <div class="filter-option-inner">
                                                    <div class="filter-option-inner-inner">По количеству просмотров</div>
                                                </div>
                                            </div>
                                        </button>
                                        <div class="dropdown-menu" role="combobox" style="max-height: 181px; overflow: hidden; min-height: 0px; position: absolute; transform: translate3d(0px, 40px, 0px); top: 0px; left: 0px; will-change: transform;" x-placement="bottom-start">
                                            <div class="inner show" role="listbox" aria-expanded="false" tabindex="-1" style="max-height: 163px; overflow-y: auto; min-height: 0px;">
                                                <ul class="dropdown-menu inner show">
                                                    <li class="selected active">
                                                        <a role="option" class="dropdown-item selected active" aria-disabled="false" tabindex="0" aria-selected="true">
                                                            <span class=" bs-ok-default check-mark"></span>
                                                            <span class="text">По количеству просмотров</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false">
                                                            <span class=" bs-ok-default check-mark"></span>
                                                            <span class="text">По количеству сохранений</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a role="option" class="dropdown-item" aria-disabled="false" tabindex="0" aria-selected="false">
                                                            <span class=" bs-ok-default check-mark"></span>
                                                            <span class="text">По количеству заказов</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <div
                                class="cabinet-table-options d-flex flex-justify-sb flex-align-center pt-0 pb-0"
                            >
                                <section
                                    class="cabinet-table-options flex flex-justify-sb flex-align-center d-flex"
                                >
                                    <div class="d-none d-md-block">
                                        <select-picker
                                            :current-value="pagination.pageSize"
                                            :options="pageSizes"
                                            key-value="id"
                                            key-title="title"
                                            select-width="80"
                                            :classes="[
                                                'select',
                                                'select--small'
                                            ]"
                                            @onChange="onPageSizeChange($event)"
                                        />
                                    </div>
                                    <div class="d-md-none">
                                        {{
                                            pagination.page *
                                                pagination.pageSize +
                                                1 -
                                                pagination.pageSize
                                        }}
                                        -
                                        {{
                                            Math.min(
                                                pagination.page *
                                                    pagination.pageSize,
                                                pagination.totalProducts
                                            )
                                        }}

                                        из {{ pagination.totalProducts }}
                                    </div>
                                </section>
                                <div
                                    class="cabinet-table-options-pagination flex flex-justify-sb flex-align-center d-none d-md-flex"
                                >
                                    <table-pagination
                                        :current-page="pagination.page"
                                        :total-pages="pagination.totalPages"
                                        :total-products="
                                            pagination.totalProducts
                                        "
                                        @setPage="onSetPage($event)"
                                    />
                                </div>
                            </div>
                        </section>

                        <section class="cabinet-supplier-table">
                            <div
                                v-for="(product, index) in products"
                                :key="index"
                                class="cabinet-table__row pt-4 pb-4"
                            >
                                <div
                                    class="d-flex align-items-md-center flex-column flex-md-row"
                                >
                                    <div
                                        class="cabinet-table__info d-flex align-items-center"
                                    >
                                        <router-link
                                            :to="
                                                `/account/products/${product.ItemID}/detail`
                                            "
                                            class="mr-3"
                                        >
                                            <img
                                                v-if="
                                                    product.images[0] &&
                                                        product.images[0].url
                                                "
                                                :src="product.images[0].url"
                                                alt=""
                                                class="cabinet-supplier-table__img cabinet-supplier-table__img--large ofi"
                                            />
                                            <img
                                                v-else
                                                src="/img/icons/eye.svg"
                                                alt=""
                                                class="cabinet-supplier-table__img cabinet-supplier-table__img--large ofi"
                                            />
                                        </router-link>
                                        <router-link
                                            :to="
                                                `/account/products/${product.ItemID}/detail`
                                            "
                                            class="dashboard-list__catalog"
                                        >
                                            <div
                                                class="dashboard-list__cell-name mb-2"
                                            >
                                                {{ product.Name }}
                                            </div>
                                            <div class="app-link">
                                                <span
                                                    class="cabinet-supplier-table__code"
                                                    >Арт.</span
                                                >
                                                {{ product.Article }}
                                            </div>
                                        </router-link>
                                    </div>
                                    <div
                                        class="d-flex ml-5 pl-4 pl-md-0 ml-md-auto mt-2 mt-md-0"
                                    >
                                        <div
                                            class="dashboard-list__value d-flex pl-2 pl-md-0"
                                        >
                                            <div
                                                class="dashboard-list__value-icon"
                                            >
                                                <img
                                                    src="/img/icons/eye.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div
                                                class="dashboard-list__value-number"
                                            >
                                                {{ product.statistics.views }}
                                            </div>
                                        </div>
                                        <div
                                            class="dashboard-list__value d-flex ml-3"
                                        >
                                            <div
                                                class="dashboard-list__value-icon"
                                            >
                                                <img
                                                    src="/img/icons/star-2.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div
                                                class="dashboard-list__value-number"
                                            >
                                                {{ product.statistics.list }}
                                            </div>
                                        </div>
                                        <div
                                            class="dashboard-list__value d-flex ml-3"
                                        >
                                            <div
                                                class="dashboard-list__value-icon"
                                            >
                                                <img
                                                    src="/img/icons/orders-2.svg"
                                                    alt=""
                                                />
                                            </div>
                                            <div
                                                class="dashboard-list__value-number"
                                            >
                                                {{ product.statistics.shop }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section
                            class="cabinet-table-options flex flex-justify-sb flex-align-center d-none d-lg-flex"
                        >
                            <select-picker
                                :current-value="pagination.pageSize"
                                :options="pageSizes"
                                key-value="id"
                                key-title="title"
                                select-width="80"
                                :classes="['select', 'select--small']"
                                @onChange="onPageSizeChange($event)"
                            />

                            <table-pagination
                                :current-page="pagination.page"
                                :total-pages="pagination.totalPages"
                                :total-products="pagination.totalProducts"
                                @setPage="onSetPage($event)"
                            />
                        </section>

                        <section
                            v-if="pagination.page < pagination.totalPages"
                            class="cabinet-pagination flex flex-column flex-align-center d-lg-none"
                        >
                            <button
                                type="button"
                                class="cabinet-btn cabinet-btn--default"
                                :disabled="
                                    pagination.page >= pagination.totalPages
                                "
                                @click="
                                    updateProductsList(
                                        pagination.page + 1,
                                        true
                                    )
                                "
                            >
                                Загрузить еще
                            </button>
                        </section>
                    </div>
                </template>
            </section>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import _ from 'lodash'
import ClickOutside from 'vue-click-outside'
import CategoryCard from '@/components/Cabinet/Supplier/Statistics/CategoryCard.vue'
import SelectPicker from '@/components/Elements/SelectPicker'
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import initSelectPicker from '@/mixins/initSelectPicker'
import getNameById from '@/mixins/getNameById'
import onResize from '@/mixins/on-resize'

let pageSizes = [10, 20, 50, 100].map(item => {
    return {
        id: item,
        title: item
    }
})

export default {
    name: 'GlobalStatistics',
    components: {
        CategoryCard,
        SelectPicker,
        TablePagination
    },
    directives: {
        ClickOutside
    },
    mixins: [initSelectPicker, getNameById, onResize],
    data() {
        return {
            search: '',
            filter: {
                categories: {
                    title: 'Категория',
                    srcName: 'categories', //name of store arr
                    srcKeyVal: 'CategoryID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'categoriesValuesArr',
                    isDefault: true, //если default, то параметры не отправляются в запрос
                    apiFilterName: 'categories'
                },
                types: {
                    title: 'Вид изделия',
                    srcName: 'typesByCategories',
                    srcKeyVal: 'TypeID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'typesValuesArr',
                    isDefault: true,
                    apiFilterName: 'types'
                },
                materials: {
                    title: 'Материал',
                    srcName: 'materials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'materialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'materials'
                },
                finenesses: {
                    title: 'Проба',
                    srcName: 'finenessesByMaterials',
                    srcKeyVal: 'FinenessID',
                    srcKeyTitle: 'Value',
                    value: [],
                    defaultValArrName: 'finenessesValuesArr',
                    isDefault: true,
                    apiFilterName: 'finenesses'
                },
                insertMaterials: {
                    title: 'Материал вставки',
                    srcName: 'insertMaterials',
                    srcKeyVal: 'MaterialID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'insertMaterialsValuesArr',
                    isDefault: true,
                    apiFilterName: 'inserts_materials'
                },
                collections: {
                    title: 'Коллекция',
                    srcName: 'supplierCollections',
                    srcKeyVal: 'CollectionID',
                    srcKeyTitle: 'Name',
                    value: [],
                    defaultValArrName: 'supplierCollectionsValuesArr',
                    isDefault: true,
                    apiFilterName: 'collections'
                },
                visibility: {
                    title: 'Видимость',
                    srcName: 'supplierVisibility',
                    srcKeyVal: 'id',
                    srcKeyTitle: 'title',
                    value: [],
                    defaultValArrName: 'visibilityOptionsArr',
                    isDefault: true,
                    apiFilterName: 'accesses'
                }
            },
            sortVariations: [
                {
                    value: 'views',
                    title: 'По количеству просмотров'
                },
                {
                    value: 'list',
                    title: 'По количеству сохранений'
                },
                {
                    value: 'shop',
                    title: 'По количеству заказов'
                }
            ],
            order_by: 'views',
            level1mFilter: false,
            level2mFilter: false,
            pageSizes,
            selectedProducts: [],
            loading: true,
            loadingProducts: true,
            previousModalName: '', // 'changeCollectionMass', 'manageCollection'
            manageCollectionId: ''
        }
    },
    computed: {
        ...mapGetters('supplierStats', ['categoryStats']),
        ...mapState('supplierProducts', [
            'products',
            'errors',
            'mobileProducts',
            'pagination'
        ]),
        ...mapState('categories', { categories: 'supplierCategories' }),
        ...mapGetters('categories', {
            categoriesValuesArr: 'supplierCategoriesValuesArr'
        }),
        ...mapState('types', { types: 'supplierTypes' }),
        ...mapGetters('types', {
            getTypesByCategories: 'getSupplierTypesByCategories',
            typesValuesArr: 'supplierTypesValuesArr'
        }),
        ...mapState('materials', { materials: 'supplierMaterials' }),
        ...mapGetters('materials', {
            materialsValuesArr: 'supplierMaterialsValuesArr'
        }),
        ...mapState('finenesses', { finenesses: 'supplierFinenesses' }),
        ...mapGetters('finenesses', {
            getFinenessesByMaterials: 'getSupplierFinenessesByMaterials',
            finenessesValuesArr: 'supplierFinenessesValuesArr',
            getFinenessesNamesArr: 'getSupplierFinenessesNamesArr'
        }),
        ...mapState('insert', { insertMaterials: 'supplierInsertMaterials' }),
        ...mapGetters('insert', {
            insertMaterialsValuesArr: 'supplierInsertMaterialsValuesArr'
        }),
        ...mapState('purposes', ['purposes']),
        ...mapState('supplierCollections', [
            'collections',
            'supplierCollections'
        ]),
        ...mapGetters('supplierCollections', [
            'getCollectionBrandId',
            'supplierCollectionsValuesArr'
        ]),
        ...mapGetters('other', ['supplierVisibility', 'visibilityOptionsArr']),
        noDataStatistic() {
            return (
                !this.categoryStats.overall_statistics.views &&
                !this.categoryStats.overall_statistics.list &&
                !this.categoryStats.overall_statistics.shop
            )
        },
        typesByCategories() {
            return this.getTypesByCategories(this.filter.categories.value)
        },
        finenessesByMaterials() {
            return this.getFinenessesByMaterials(this.filter.materials.value)
        },
        finenessesNamesArr() {
            return this.getFinenessesNamesArr(this.filter.finenesses.value)
        },
        isAllDefaultValues() {
            return (
                Object.keys(this.filter).filter(
                    item => !this.filter[item].isDefault
                ).length === 0
            )
        },
        appliedFiltersCount() {
            return Object.keys(this.filter).filter(
                item => this.filter[item].value.length
            ).length
        },
        paginatedProducts() {
            if (document.documentElement.clientWidth > 1024) {
                return this.products
            }
            return this.mobileProducts
        },
        massCollectionBrandId() {
            if (!this.selectedProducts.length) return ''
            let brandsIds = {} //test same brand
            this.selectedProducts.forEach(id => {
                let product = this.paginatedProducts.find(
                    paginatedProduct => paginatedProduct.ItemID == id
                )

                if (product) {
                    brandsIds[product.BrandID] = true
                }
            })
            return Object.keys(brandsIds).length === 1
                ? parseInt(Object.keys(brandsIds)[0])
                : ''
        },
        manageCollectionBrandId() {
            if (!this.manageCollectionId) return ''
            return this.getCollectionBrandId(this.manageCollectionId)
        }
    },
    beforeRouteEnter(to, from, next) {
        const lsSearch = window.localStorage.getItem('productsSearch')

        const lsPage = window.localStorage.getItem('productsPage')

        const lsFilters = JSON.parse(
            window.localStorage.getItem('productsFilter') || '{}'
        )

        const notDefault = Object.keys(lsFilters).filter(
            item => !lsFilters[item].isDefault
        )

        const parentRouteName =
            from && from.matched.length ? from.matched[0].name : ''

        next(vm => {
            //если переданы настройки фильров в параметрах роута, то используем их
            //иначе, если был переход со страницы редактирования изделия, то берем настройки из ls

            if (Object.keys(vm.$route.params).length) {
                if (vm.$route.params.type_id) {
                    vm.filter.types.value = new Array(1).fill(
                        vm.$route.params.type_id
                    )
                    vm.onFilterChange('types')
                }

                if (vm.$route.params.category_id) {
                    vm.filter.categories.value = new Array(1).fill(
                        vm.$route.params.category_id
                    )
                    vm.onFilterChange('categories')
                }

                if (vm.$route.params.collection_id) {
                    vm.filter.collections.value = new Array(1).fill(
                        vm.$route.params.collection_id
                    )
                    vm.onFilterChange('collections')
                }

                console.log('Filter types installed from route params')
            } else if (
                ['SupplierProductsEdit', 'SupplierProductsDetail'].includes(
                    parentRouteName
                )
            ) {
                if (notDefault.length) {
                    notDefault.forEach(filterKey => {
                        vm.filter[filterKey].value = lsFilters[filterKey].value
                        vm.onFilterChange(filterKey)
                    })
                    console.log('Filters installed from ls')
                }

                if (lsSearch) {
                    vm.search = lsSearch
                    vm.updateProductsList(1)
                }

                if (lsPage && !vm.isMobile) {
                    vm.onSetPage(lsPage)
                }
            }
        })
    },
    beforeRouteLeave(to, from, next) {
        if (this.isAllDefaultValues) {
            window.localStorage.removeItem('productsFilter')
        } else {
            window.localStorage.setItem(
                'productsFilter',
                JSON.stringify(this.filter)
            )
        }

        if (this.search) {
            window.localStorage.setItem('productsSearch', this.search)
        } else {
            window.localStorage.removeItem('productsSearch')
        }

        if (this.pagination.page > 1) {
            window.localStorage.setItem('productsPage', this.pagination.page)
        } else {
            window.localStorage.removeItem('productsPage')
        }

        next()
    },
    async created() {
        await this.getCategoryStats()

        this.loading = false
    },
    async mounted() {
        //выполняем после beforeRouteEnter
        this.$nextTick(async () => {
            this.tryLoadingProducts()
        })
    },
    async destroyed() {
        this.clearProducts()
    },
    methods: {
        ...mapActions('supplierStats', ['getCategoryStats']),
        ...mapMutations('supplierProducts', ['SET_PAGINATION']),
        ...mapActions('supplierProducts', ['getProducts']),
        ...mapActions('supplierProducts', ['clearProducts']),
        ...mapActions('categories', ['getCategories']),
        ...mapActions('types', ['getTypes']),
        ...mapActions('materials', ['getMaterials']),
        ...mapActions('finenesses', ['getFineness']),
        ...mapActions('insert', ['getInsertMaterials']),
        ...mapActions('supplierCollections', ['getCollections']),
        ...mapActions('other', ['getVisibility']),
        onSelectPickerChange(type, val) {
            this.filter[type].value = val
            this.onFilterChange(type)
        },
        setFilters() {
            if (!this.categories.length) {
                this.getCategories({ existing: true, sort_by: 'Position' })
            }

            if (!this.types.length) {
                this.getTypes({ existing: true })
            }

            if (!this.materials.length) {
                this.getMaterials({ existing: true })
            }

            if (!this.finenesses.length) {
                this.getFineness({ existing: true })
            }

            if (!this.insertMaterials.length) {
                this.getInsertMaterials({ existing: true })
            }

            if (!this.supplierCollections.length) {
                this.getCollections({ existing: true })
            }

            if (!this.supplierVisibility.length) {
                this.getVisibility({ existing: true })
            }
        },
        setlevel2mFilters(filterKey) {
            this.level2mFilter = filterKey
        },
        resetFilters() {
            Object.keys(this.filter).forEach(item => {
                this.filter[item].isDefault = true
                this.filter[item].value = []
            })
            this.updateProductsList(1)
            this.closeAllmFilters()
        },
        closeAllmFilters() {
            this.level2mFilter = false
            this.level1mFilter = false
        },
        onFilterChange(filterType) {
            this.filter[filterType].isDefault = !this.filter[filterType].value
                .length

            this.updateProductsList(1)
        },
        updateProductsList: _.debounce(function(
            page = 1,
            isMobilePagination = false
        ) {
            this.updateProductsListFunc(page, isMobilePagination)
        },
        800),
        async updateProductsListFunc(page = 1, isMobilePagination = false) {
            this.loadingProducts = true
            this.$Progress.start()
            this.selectedProducts = []

            let data = { page, isMobilePagination }
            Object.keys(this.filter).forEach(item => {
                if (!this.filter[item].isDefault) {
                    let valuesArr = [...this.filter[item].value]

                    if (item === 'finenesses') {
                        valuesArr = [...this.finenessesNamesArr]
                    }

                    if (!valuesArr.length) {
                        valuesArr = [null]
                    }

                    data[this.filter[item].apiFilterName] = valuesArr
                }
            })

            if (this.search) {
                data.search = this.search
            }

            data.statistics = 1
            data.order_by = this.order_by

            await this.getProducts(data)

            this.loadingProducts = false
        },
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.updateProductsList(page)
        },
        onPageSizeChange(val) {
            this.SET_PAGINATION({
                key: 'pageSize',
                val
            })

            this.updateProductsList(1)
        },
        onSearch() {
            this.$Progress.start()
            this.updateProductsList(1)
        },
        onClearSearch() {
            this.search = ''
            this.$Progress.start()
            this.updateProductsList(1)
        },
        onSortChange(value) {
            this.$Progress.start()
            this.order_by = value

            this.updateProductsList(1)
        },
        async tryLoadingProducts() {
            const lsPage = window.localStorage.getItem('productsPage')
            if (this.isAllDefaultValues && !this.search && !lsPage) {
                await this.updateProductsListFunc(1)
            } else {
                await this.updateProductsList(lsPage || 1)
            }

            this.setFilters()
            this.getCollections()
        }
    }
}
</script>
